<template>
  <div class="container_self">
    <el-row class="table_parent">
      <el-row class="search_parent">
        <h3>搜索</h3>
        <el-form :model="searchForm" size="mini" class="search_parent" :inline="true">
          <el-form-item label="UDID">
            <el-input
              v-model="searchForm.udid"
              clearable
              placeholder="请输入udid"
            ></el-input>
          </el-form-item>
          <el-form-item label="NEWUDID">
            <el-input
              v-model="searchForm.newUdid"
              clearable
              placeholder="请输入newUdid"
            ></el-input>
          </el-form-item>
          <el-form-item label="事件名称">
            <el-select
              v-model="searchForm.name"
              clearable
              placeholder="请选择事件名称"
              @change="eventChange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="事件状态" v-if="showStatus">
            <el-select v-model="status" clearable placeholder="请选择事件状态">
              <el-option label="所有状态" value=""></el-option>
              <el-option label="成功" value="success"></el-option>
              <el-option label="失败" value="failed"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间">
            <el-date-picker
              v-model="dataZoom"
              :default-timezone="0"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              clearable
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="URL">
            <el-input
              v-model="searchForm.pageUrl"
              clearable
              placeholder="请输入pageUrl"
            ></el-input>
            <el-button type="warning" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>

      <h3>H5 事件列表</h3>
      <el-table
        :data="tableData"
        v-loading="loading"
        element-loading-text="加载中，请稍后"
        style="width: 100%"
      >
        <!-- <el-table-column align="center" prop="customerName" label="所属客户"></el-table-column> -->
        <el-table-column prop="udid" align="center" label="UDID"> </el-table-column>
        <el-table-column prop="newUdid" align="center" label="NEWUDID"> </el-table-column>
        <el-table-column prop="name" align="center" label="事件名称"> </el-table-column>
        <el-table-column prop="extraInfo" align="center" label="扩展信息">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.extraInfo"
              placement="top"
            >
              <span class="table_span">{{ scope.row.extraInfo }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="浏览器信息" width="230">
          <template slot-scope="scope">
            <!-- <el-popover trigger="click" placement="top">

              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" @click="checkEnv(scope.row.id)">查看浏览器信息</el-tag>
              </div>
            </el-popover> -->
            <!-- <el-tag size="medium" @click="checkEnv">查看浏览器信息</el-tag> -->
            <el-popover placement="top" width="200" trigger="click">
              <p v-for="(value, key) in env" :key="key">{{ key }} : {{ value }}</p>
              <!-- <el-button>click 激活</el-button> -->
              <el-tag size="medium" slot="reference" @click="checkEnv(scope.row.id)"
                >查看浏览器信息</el-tag
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="事件状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'success'" style="color: rgb(80, 204, 107)"
              >成功</span
            >
            <span v-if="scope.row.status === 'failed'" style="color: rgb(150, 146, 142)"
              >失败</span
            >
            <span v-if="!scope.row.status">--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="广告单元ID"
          prop="unitid"
          align="center"
        ></el-table-column>
        <el-table-column
          label="触发事件URL"
          prop="pageUrl"
          align="center"
        ></el-table-column>
        <el-table-column prop="pageTime" align="center" label="事件发生时间">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row.id, scope.row.customerName, scope.row.name)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="selfpage">
        <el-pagination
          @size-change="handleSizeChange"
          @next-click="nextClick"
          @prev-click="prevClick"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, next"
          :total="total"
        >
        </el-pagination>

        <span class="currentPage">{{ "第 " + currentPage + " 页" }}</span>

        <span class="currentPage" style="color: #6d6d6d">{{ "50条/页" }}</span>
      </div>
    </el-row>
  </div>
</template>

<style>
.selfpage .el-icon-arrow-left::before {
  content: "" !important;
}
.selfpage .el-icon-arrow-right::before {
  content: "" !important;
}
.selfpage {
  display: flex;
  align-items: center;
}
.selfpage .btn-next::after {
  content: "下一页";
}
.selfpage .btn-prev::after {
  content: "上一页";
}
body .selfpage .el-pagination {
  margin: 0;
}
body .selfpage {
  margin-top: 30px;
}
.currentPage {
  margin-left: 10px;
  font-size: 13px;
  line-height: 28px;
  color: #303133;
}
.el-tag {
  cursor: pointer;
}
</style>
<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
import { formateDateLong } from "@/assets/dateUtils.js";
export default {
  data() {
    return {
      status: "",
      showStatus: false,
      total: 0,
      loading: false,
      currentPage: 1,
      tableData: [],
      searchForm: {
        customerName: "",
        name: "",
        start: "",
        end: "",
        pageSize: 50,
        udid: "",
        newUdid: "",
        pageUrl: "",
        pageType: "",
      },
      pageSize: 50,
      options: [
        { value: "pageEnterEvent", label: "进入页面" },
        { value: "pageReadyEvent", label: "页面资源加载完成" },
        { value: "pageExitEvent", label: "页面退出" },
        { value: "adDivP1VisibleEvent", label: "P1可见" },
        { value: "adDivP2VisibleEvent", label: "P2可见" },
        { value: "adDivP1DisVisibleEvent", label: "P1不可见" },
        { value: "adDivP2DisVisibleEvent", label: "P2不可见" },
        { value: "scrollEvent", label: "页面滚动" },
        { value: "clickEvent", label: "页面点击" },
        { value: "adDivPMDisVisibleEvent", label: "可见区域小于百分之50" },
        { value: "adInitEvent", label: "ad初始化" },
        { value: "adFilledEvent", label: "广告填充" },
        { value: "greatAdEvent", label: "自有广告事件" },
        { value: "Taboolanews userAgent", label: "Taboolanews userAgent" },
      ],
      dataZoom: [],
      env: "",
      pageIdPrev: "",
      pageIdNext: "",
    };
  },
  methods: {
    eventChange(value) {
      this.status = "";
      if (value === "adFilledEvent" || value === "adInitEvent") {
        this.showStatus = true;
      } else {
        this.showStatus = false;
      }
    },
    search() {
      this.pageSize = 50;
      this.currentPage = 1;
      this.searchForm.currentPage = 1;
      // console.log(this.dataZoom);
      if (this.dataZoom) {
        if (this.dataZoom.length) {
          let start = this.dataZoom[0];
          let end = this.dataZoom[1];
          // console.log(start,end);
          this.searchForm.start = start;
          this.searchForm.end = end;
          console.log(this.searchForm.start, this.searchForm.end);
        }
      } else {
        this.searchForm.start = "";
        this.searchForm.end = "";
      }

      if (this.showStatus) {
        this.searchForm.status = this.status;
      }
      let getTotalRequest = JSON.parse(JSON.stringify(this.searchForm));
      delete getTotalRequest.pageSize;
      delete getTotalRequest.pageType;
      delete getTotalRequest.pageId;
      this.getEventList(getTotalRequest);
      this.getTotal(getTotalRequest);
    },
    handleDelete(id, custom, name) {
      this.$confirm(`此操作将永久删除${custom}下的这条${name}的记录, 是否继续?`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/event/delete", { ids: [id] }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "该记录已删除", type: "success" });
              this.getEventList(this.searchForm);
            }
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      // if(val)
      this.pageSize = val;
      this.currentPage = 1;
      this.searchForm.currentPage = this.currentPage;
      this.searchForm.pageSize = val;
      this.getEventList(this.searchForm);
    },
    handleCurrentChange(val) {
      if (val > this.currentPage) {
        this.searchForm.pageType = -1;
      } else {
        this.searchForm.pageType = 1;
      }
      this.currentPage = val;
      this.searchForm.pageSize = this.pageSize;
      this.getEventList(this.searchForm);
    },
    nextClick() {
      this.searchForm.pageType = -1;
      this.searchForm.pageId = this.pageIdNext;
      this.getEventList(this.searchForm);
    },
    prevClick() {
      this.searchForm.pageType = 1;
      this.searchForm.pageId = this.pageIdPrev;
      this.getEventList(this.searchForm);
    },
    checkEnv(id) {
      this.env = "";
      axiosGet("/api/v2/web/event/detail?id=" + id).then((res) => {
        if (res.code == 0) {
          this.env = this.analyzeBrowserInfo(res.data.env);
        }
      });
    },
    analyzeBrowserInfo(string) {
      if (string) {
        const ua = string;

        // 是否是移动端
        const isMobile = /Mobile|Android|iPhone|iPad/i.test(ua);

        // 设备 / 系统信息（括号内）
        const deviceMatch = ua.match(/\(([^)]+)\)/);
        const deviceInfo = deviceMatch ? deviceMatch[1] : "";

        // 操作系统平台
        let osPlatform = "Unknown";
        if (/Windows NT/.test(ua)) osPlatform = "Windows";
        else if (/Android/.test(ua)) osPlatform = "Android";
        else if (/iPhone|iPad/.test(ua)) osPlatform = "iOS";
        else if (/Mac OS X/.test(ua)) osPlatform = "macOS";

        // 浏览器名称 & 版本
        let browserName = "Unknown";
        let browserVersion = "";

        let match;
        if ((match = ua.match(/Edg\/([\d.]+)/))) {
          browserName = "Edge";
          browserVersion = match[1];
        } else if ((match = ua.match(/Chrome\/([\d.]+)/))) {
          browserName = "Chrome";
          browserVersion = match[1];
        } else if ((match = ua.match(/Firefox\/([\d.]+)/))) {
          browserName = "Firefox";
          browserVersion = match[1];
        } else if ((match = ua.match(/Version\/([\d.]+).*Safari/))) {
          browserName = "Safari";
          browserVersion = match[1];
        }

        // 浏览器内核
        let browserEngine = "Unknown";
        let browserEngineVersion = "";

        if ((match = ua.match(/AppleWebKit\/([\d.]+)/))) {
          browserEngine = "AppleWebKit";
          browserEngineVersion = match[1];
        }
        let browserObj = {
          BrowserNameVersion: `${browserName} ${browserVersion}`,
          "OS Platform": osPlatform,
          "Is Mobile": isMobile,
          "Browser Engine": browserEngine,
          "Browser Engine Version": browserEngineVersion,
          "Browser Version": browserVersion,
          "Device Info": deviceInfo,
        };
        return browserObj;
      } else {
        return { 事件信息: "该事件无拓展信息" };
      }
    },
    async getEventList(params) {
      // console.log(params);
      this.loading = true;
      let request = {
        pageSize: params.pageSize,
        start: params.start || "",
        name: params.name || "",
        end: params.end || "",
        udid: params.udid || "",
        newUdid: params.newUdid || "",
        pageUrl: params.pageUrl || "",
        // nextCreateTime:params.nextCreateTime||"",
        // prevCreateTime:params.prevCreateTime||"",
        pageId: params.pageId || "",
        status: params.status || "",
        pageType: params.pageType || "",
      };
      if (this.showStatus) {
        request.status = params.status;
      }
      const res = await axiosGet("/api/v2/web/event/list", request);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data;
        this.pageIdPrev = res.data[0].id;
        this.pageIdNext = res.data[res.data.length - 1].id;
      }
    },
    async getTotal(params) {
      this.loading = true;
      let request = {
        start: params.start || "",
        name: params.name || "",
        end: params.end || "",
        udid: params.udid || "",
        newUdid: params.newUdid || "",
        pageUrl: params.pageUrl || "",
        status: params.status || "",
      };
      const resTotal = await axiosGet("/api/v2/web/event/count", request);
      // console.log(resTotal);
      this.loading = false;
      if (resTotal.code == 0) {
        this.total = resTotal.data;
      }
    },
  },
  mounted() {
    this.getEventList(this.searchForm);
    this.getTotal(this.searchForm);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/h5EventsList.vue